function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10.75A4.26 4.26 0 011.25 6.5 4.26 4.26 0 015.5 2.25 4.26 4.26 0 019.75 6.5a4.26 4.26 0 01-4.25 4.25zm0-7c-1.52 0-2.75 1.23-2.75 2.75S3.98 9.25 5.5 9.25 8.25 8.02 8.25 6.5 7.02 3.75 5.5 3.75zm0 18a4.26 4.26 0 01-4.25-4.25 4.26 4.26 0 014.25-4.25 4.26 4.26 0 014.25 4.25 4.26 4.26 0 01-4.25 4.25zm0-7c-1.52 0-2.75 1.23-2.75 2.75s1.23 2.75 2.75 2.75 2.75-1.23 2.75-2.75-1.23-2.75-2.75-2.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.65 16.73a.75.75 0 01-.45-1.35L21.55 5.4a.75.75 0 01.9 1.2L9.1 16.58c-.13.1-.29.15-.45.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 18.72a.76.76 0 01-.45-.15L8.2 8.59a.75.75 0 01.9-1.2l13.35 9.98a.75.75 0 01-.45 1.35z"
})));